import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from "react";
import { tv } from "tailwind-variants";
import { cn } from "../cn";
import { Txt } from "./text";
const variants = tv({
    // TODO: using flex + center here might not be wise as a default
    base: `font-title`,
    variants: {
        type: {
            "page-title": "text-2xl font-normal leading-6 tracking-[-0.02em]",
            "card-title": "text-base font-medium leading-5 tracking-[-0.02em]",
            section: "text-base font-medium leading-5 tracking-[-0.02em]",
            account: "text-sm font-medium leading-5 tracking-[-0.02em]",
            subtitle: "font-text text-sm font-normal leading-[18px] tracking-normal text-secondary",
            field: "text-sm font-normal leading-4 tracking-normal",
            "table-header": "text-xs font-medium leading-4 tracking-[-0.01em] text-secondary",
        },
        flexCenter: {
            true: "inline-flex items-center gap-2",
            false: "",
        },
        truncate: {
            true: "truncate min-w-0",
        },
    },
});
export const Heading = forwardRef(function Heading({ type, flexCenter = true, truncate, ...props }, ref) {
    return (_jsx(Txt, { ref: ref, ...props, 
        /* We're overriding line-height here because we need to figure out a way to get 0 padding/margin on the outside of the components (like Mark Dalgleish), and for a gradual migration */
        className: cn(variants({ type, flexCenter, truncate }), "leading-none", props.className) }));
});
